import Client from '@/api/client'
import { getConfig } from '@/app/config'
import { PaginatedBookingsDTO } from '@/clients/booking'
import { bookingToOverviewItem } from '@/features/shipments/api/bookingToOverviewItem'
import { OverviewItemResponse } from '@/features/shipments/domain/overviewItem'

import { BookingLookupResponse, BookingPageParams } from '../types'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const getBookingLookup = async (): Promise<BookingLookupResponse> => {
  const results = await client.get<BookingLookupResponse>('/api/booking-v2/filters-lookups')
  return results
}

export const getBookings = async ({ pageParam }: { pageParam: BookingPageParams }): Promise<PaginatedBookingsDTO> => {
  return client.get<PaginatedBookingsDTO>('/api/booking-v2/bookings', { params: pageParam })
}

export const getOverviewListBookings = async ({
  pageParam,
}: {
  pageParam: BookingPageParams
}): Promise<OverviewItemResponse> => {
  const result = await getBookings({ pageParam })
  const overviewItems = result.items.map((booking) => bookingToOverviewItem(booking))

  return {
    items: overviewItems,
    total: result.totalItems,
  }
}
